export const matrixSort = items => {
  if (!Array.isArray(items)) return []

  const getValue = item => {
    if (item == null) return ''
    if (typeof item === 'string') return item
    if (item.matrixDetails) {
      const firstKey = Object.keys(item.matrixDetails)[0]
      return item.matrixDetails[firstKey]
    }
    const keys = Object.keys(item)
    if (keys.length === 1) return item[keys[0]]
    return ''
  }

  const getSizeRank = val => {
    if (!val) return null
    const normalized = val.toLowerCase().replace(/\s+/g, '')
    if (normalized === 'xx-small') return 0
    if (normalized === 'x-small') return 1
    if (normalized === 'small') return 2
    if (normalized === 'medium') return 3
    if (normalized === 'large') return 4
    if (normalized === 'x-large' || normalized === 'xlarge') return 5
    const matchNumXL = normalized.match(/^(\d+)x-large$/)
    if (matchNumXL) return 5 + parseInt(matchNumXL[1], 10)
    const matchXSeq = normalized.match(/^(x{2,})-?large$/)
    if (matchXSeq) return 4 + matchXSeq[1].length
    return null
  }

  const parseNumeric = str => {
    if (!str) return null
    const numMatch = str.match(/(\d+(?:\.\d+)?)/)
    if (!numMatch) return null
    const num = parseFloat(numMatch[1])
    const rest = str.slice(numMatch.index + numMatch[0].length).toLowerCase()
    const unitMatch = rest.match(/[a-z]+/)
    const unit = unitMatch ? unitMatch[0] : ''
    const unitMap = {
      oz: 1,
      ounce: 1,
      ounces: 1,
      lb: 16,
      lbs: 16,
      pound: 16,
      pounds: 16,
      gal: 128,
      gallon: 128,
      gallons: 128,
      ml: 0.033814,
      l: 33.814,
      liter: 33.814,
      liters: 33.814,
    }
    const factor = unitMap[unit] || 1
    return num * factor
  }

  const compare = (aVal, bVal) => {
    if (aVal === undefined || aVal === null) return -1
    if (bVal === undefined || bVal === null) return 1

    const aSize = getSizeRank(aVal)
    const bSize = getSizeRank(bVal)
    if (aSize !== null && bSize !== null) return aSize - bSize
    if (aSize !== null) return -1
    if (bSize !== null) return 1

    const aNum = parseNumeric(aVal)
    const bNum = parseNumeric(bVal)
    if (aNum !== null && bNum !== null) return aNum - bNum
    if (aNum !== null) return -1
    if (bNum !== null) return 1

    return aVal.localeCompare(bVal)
  }

  return [...items].sort((a, b) => {
    const aVal = getValue(a)
    const bVal = getValue(b)
    return compare(aVal, bVal)
  })
}

export default matrixSort
